/**
 * sections.js
 *
 * Import the JS for your sections here.
 *
 */
import './anchor-content/s-anchor-content';
import './sitemap/s-sitemap';
import './footer-nav/s-footer-nav';
import './newsletter-signup/s-newsletter-signup';
import './notification/s-notification';
import './desktop-header/s-desktop-header';
import './mobile-header/s-mobile-header';
import './page-header/s-page-header';
import './algolia-filter/s-algolia-filter';
import './page-profile-header/s-page-profile-header';
import './sticky-nav/s-sticky-nav';
import './case-study/s-case-study';



// WEBPACK FOOTER //
// ./src/sections/sections.js